import { motion } from "framer-motion";
import { Instagram, Phone, MapPin, ArrowRight } from "lucide-react";
import { BUSINESS } from "../data";
import { SectionHeading } from "./SectionHeading";

export const Contact = ({ onBook }) => {
  const items = [
    {
      icon: Phone,
      label: "Call or Text",
      value: BUSINESS.phone,
      href: `tel:${BUSINESS.phoneRaw}`,
      testid: "contact-phone",
    },
    {
      icon: Instagram,
      label: "Follow Us",
      value: `@${BUSINESS.instagram}`,
      href: BUSINESS.instagramUrl,
      testid: "contact-instagram",
    },
    {
      icon: MapPin,
      label: "Location",
      value: BUSINESS.location,
      href: `https://maps.google.com/?q=${encodeURIComponent(BUSINESS.location)}`,
      testid: "contact-location",
    },
  ];

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative z-10 py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          overline="Get In Touch"
          title="Ready to bring your car back to life?"
          subtitle={BUSINESS.serving}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {items.map((it, i) => (
            <motion.a
              key={it.label}
              href={it.href}
              target={it.href.startsWith("http") ? "_blank" : undefined}
              rel="noopener noreferrer"
              data-testid={it.testid}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              whileHover={{ y: -6 }}
              className="group rounded-2xl border border-white/5 bg-[#111111] p-8 hover:border-white/25 transition-colors duration-300"
            >
              <div className="h-11 w-11 rounded-full bg-white/10 flex items-center justify-center mb-6 group-hover:bg-white/20 transition-colors">
                <it.icon size={19} className="text-white" />
              </div>
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
                {it.label}
              </p>
              <p className="mt-2 font-heading text-xl font-semibold text-white">
                {it.value}
              </p>
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-8 rounded-3xl border border-white/10 bg-gradient-to-tr from-white/[0.06] to-transparent p-10 md:p-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-8"
        >
          <div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold tracking-tighter text-white">
              Book Now & Get the Marez Treatment
            </h3>
            <p className="mt-3 text-zinc-400 max-w-lg">
              Easy online booking. Premium results. Trusted across the Bay Area.
            </p>
          </div>
          <button
            data-testid="contact-book-btn"
            onClick={onBook}
            className="btn-3d gloss-sweep group shrink-0 inline-flex items-center gap-2 rounded-full bg-[#fafafa] text-[#050505] font-semibold px-8 py-4 hover:bg-white"
          >
            Book Your Detail
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
